import React from 'react';
import { ColourTheme } from '../../../../types/ColourTheme';
import i18n from 'i18next';
import { convertNumericKeysToArray } from '../../../../newHelpers/convertNumericKeysToArray';
import { stylize } from '../../../../newHelpers/stylize';
import { personaToHeroImg, personaToIgLink } from './PersonaImageMap';
import './PersonaHero.scss';

type Props = {
  theme: ColourTheme;
  toggleScroll: () => void;
};

export const PersonaHero = (props: Props) => {
  const copy: HeroCopy =  convertNumericKeysToArray(i18n.t(`${props.theme}Landing.hero`, { returnObjects: true }));

  return (
    <div className="PersonaHero">
      <div className="wrapper">
        <div className="left-container">
          <h1>{copy.title}</h1>
          <h2>{copy.subtitle}</h2>
          {copy.p?.map((item, index) =>
            <p key={index}>{stylize(item)}</p>
          )}
        </div>
        <div className="right-container">
          <div onClick={() => window.open(`https://instagram.com/${personaToIgLink[props.theme]}`, '_blank')}>
            <img src={personaToHeroImg[props.theme]} alt="persona-hero-portrait" />
          </div>
        </div>
      </div>
      <div className="cta" onClick={props.toggleScroll}>
        <button>{copy.down}</button>
        <p>&or;</p>
      </div>
    </div>
  );
};

type HeroCopy = {
  title: string;
  subtitle: string;
  p?: string[];
  down: string;
};